import { RawBuilder, sql } from 'kysely'

export function shouldStringify(value: unknown): boolean {
  if (value === null || value === undefined) {
    return false
  }

  if (typeof value !== 'object') {
    return false
  }

  // Don't stringify these types
  if (
    value instanceof Date ||
    value instanceof ArrayBuffer ||
    value instanceof Uint8Array ||
    ArrayBuffer.isView(value)
  ) {
    return false
  }

  // Stringify plain objects and arrays
  return true
}

export function json<T>(value: T): RawBuilder<T> {
  return sql`${JSON.stringify(value)}`
}

export type CastValues<T> = {
  [K in keyof T]: RawBuilder<T[K]>
}

export function castValues<T>(values: T): CastValues<T> {
  const result = {} as CastValues<T>
  for (const key in values) {
    if (shouldStringify(values[key])) {
      result[key] = json(values[key]) as RawBuilder<
        T[typeof key]
      >
    } else {
      result[key] = values[key] as RawBuilder<T[typeof key]>
    }
  }
  return result
}
